"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Spacing = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Spacing = ({
  className,
  children,
  marginSide,
  paddingSide,
  size,
  margin,
  padding,
  ...rest
}) => {
  let baseClass = "sp";

  const getSide = side => {
    switch (side) {
      case "top":
        return "t";

      case "bottom":
        return "b";

      case "left":
        return "l";

      case "right":
        return "r";

      default:
        return "";
    }
  };

  let spacingClass = [];

  if (margin) {
    spacingClass.push(`${baseClass}-${`${margin && "m"}`}${marginSide ? getSide(marginSide) : ""}--${size}`);
  }

  if (padding) {
    spacingClass.push(`${baseClass}-${`${padding && "p"}`}${paddingSide ? getSide(paddingSide) : ""}--${size}`);
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: spacingClass.join(" ")
  }, rest), children);
};

exports.Spacing = Spacing;
Spacing.defaultProps = {
  marginSide: false,
  paddingSide: false,
  size: 8,
  margin: false,
  padding: false
};
Spacing.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.oneOf(_utils.enums.size),
  marginSide: _propTypes.default.oneOf(_utils.enums.side),
  paddingSide: _propTypes.default.oneOf(_utils.enums.side),
  children: _propTypes.default.element,
  margin: _propTypes.default.string,
  padding: _propTypes.default.string
};
var _default = Spacing;
exports.default = _default;